module.exports = __webpack_public_path__ + "static/img/celoscope-33.1553348.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-33.jpg
// module id = FFO+
// module chunks = 52